<template>
   
  <div id="analitico-modelo-dois" class="w3-container w3-col s12 w3-padding-small" >
   
    <div class="w3-card w3-panel w3-padding-small" >
      <div class="container">
        <div class="w3-row">
         <!-- CONTAS A RECEBER -->
          <strong class="w3-text-theme" style="text-transform: uppercase">Contas a receber</strong>
          <div class="w3-col s12 card-box">
            <table class="w3-table w3-striped w3-bordered w3-hide-medium w3-hide-small">
              <tr style="background: #f1f1f1">
                <th><strong>Tipo</strong></th>
                <th><strong>Valor</strong></th>
                <th><strong>Previsão</strong></th>
                <th><strong>Total</strong></th>
                <th><strong>AV</strong></th>
              </tr>
              <tbody v-for="(item, index) in dados.contas_receber" :key="index">
                <tr v-if="item.mostrar" @click="toogleCard(item, false)" class="tr-items tr-items-ativo">
                  <td v-if="item.plano_financeiro_pai" >
                    {{ item.plano_financeiro_pai_id }} - {{ item.plano_financeiro_pai }}
                  </td>
                  <td v-else >
                    SEM PLANO
                  </td>
                  <td>R$ {{ formatarValor(item.soma_valor_contas_receber, 2) }}</td>
                  <td>R$ {{ formatarValor(item.soma_previsao_contas_receber, 2) }}</td>
                  <td>R$ {{ formatarValor(item.soma_total_contas_receber, 2) }}</td>
                  <td>{{ formatarValor(((item.soma_total_contas_receber / dadosMapaFinanceiro.total_receber) * 100), 4) }}</td>
                </tr>
                <tr v-if="!item.mostrar" @click="toogleCard(item, true)" class="tr-items">
                  <td v-if="item.plano_financeiro_pai"  >
                    {{ item.plano_financeiro_pai_id }} - {{ item.plano_financeiro_pai }}
                  </td>
                  <td v-else >
                    SEM PLANO
                  </td>
                  <td>R$ {{ formatarValor(item.soma_valor_contas_receber, 2) }}</td>
                  <td>R$ {{ formatarValor(item.soma_previsao_contas_receber, 2) }}</td>
                  <td>R$ {{ formatarValor(item.soma_total_contas_receber, 2) }}</td>
                  <td>{{ formatarValor(((item.soma_total_contas_receber / dadosMapaFinanceiro.total_receber) * 100), 4) }}</td>
                </tr>
                <transition name="fade" tag="tr" mode="out-in">
                  <tr colspan="5" v-if="item.mostrar" class="tr-interno-background">
                    <td class="mapa-financeiro-card" colspan="5" >
                      <table class="w3-table w3-striped w3-bordered table-interior">
                        <tr class="tr-titulo">
                          <th>Tipo</th>
                          <th>Valor</th>
                          <th>Previsão</th>
                          <th>Total</th>
                          <th>AV</th>
                        </tr>
                        <tbody>
                          <tr v-for="conta in item.contas_receber" @click="toogleCard(dados, false)" class="tr-subitems">
                            <td class="">{{ conta.nome }}</td>
                            <td>R$ {{ conta.total }}</td>
                            <td>R$ {{ conta.total_previsao }}</td>
                            <td> R$ {{ formatarValor(valor(conta.total) + valor(conta.total_previsao), 2) }}</td>
                            <td>{{ formatarValor(((valor(conta.total) + valor(conta.total_previsao)) / valor(dadosMapaFinanceiro.total_receber)) * 100, 4) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </transition>
              </tbody>
            </table>
            
            <div class="w3-hide-large card-informacoes" :class="{'card-ativo': item.mostrar}" v-for="(item, index) in dados.contas_receber" :key="index" @click="toogleCard(item, !item.mostrar)">
              <div class="w3-col s12">
                <strong>Tipo</strong>
                <label v-if="item.plano_financeiro_pai" class="w3-right">{{ item.plano_financeiro_pai_id }} - {{ item.plano_financeiro_pai }}</label>
                <label v-else class="w3-right">SEM PLANO</label>
              </div>
              <div class="w3-col s12">
                <strong>Valor</strong>
                <label class="w3-right">R$ {{ formatarValor(item.soma_previsao_contas_receber, 2) }}</label>
              </div>
              <div class="w3-col s12">
                <strong>Previsão</strong>
                <label class="w3-right">R$ {{ formatarValor(item.soma_total_contas_receber, 2) }}</label>
              </div>
              <div class="w3-col s12">
                <strong>Total</strong>
                <label class="w3-right">R$ {{ formatarValor(item.soma_total_contas_receber, 2) }}</label>
              </div>
              <div class="w3-col s12">
                <strong>AV</strong>
                <label class="w3-right">{{ formatarValor(((item.soma_total_contas_receber / dadosMapaFinanceiro.total_receber) * 100), 4) }}</label>
              </div>
              <transition-group name="fade" tag="div" mode="out-in">
                <div class="w3-hide-large card-informacoes card-interno w3-border" v-if="item.mostrar" v-for="conta in item.contas_receber" @click="toogleCard(item, false)">
                  <div class="w3-col s12">
                    <strong>Tipo</strong>
                    <label class="w3-right">{{ conta.nome }}</label>
                  </div>
                  <div class="w3-col s12">
                    <strong>Valor</strong>
                    <label class="w3-right">R$ {{ conta.total }}</label>
                  </div>
                  <div class="w3-col s12">
                    <strong>Previsão</strong>
                    <label class="w3-right">R$ {{ conta.total_previsao }}</label>
                  </div>
                  <div class="w3-col s12">
                    <strong>Total</strong>
                    <label class="w3-right"> R$ {{ formatarValor(valor(conta.total) + valor(conta.total_previsao), 2) }}</label>
                  </div>
                  <div class="w3-col s12">
                    <strong>AV</strong>
                    <label class="w3-right">{{ formatarValor(((valor(conta.total) + valor(conta.total_previsao)) / valor(dadosMapaFinanceiro.total_receber)) * 100, 4) }}</label>
                  </div>
                </div>
              </transition-group>
            </div>
          </div><!-- card-box -->
        </div><!-- row -->
        <div class="w3-row w3-margin-top w3-vermelho" style="padding: 10px">
          <strong class="w3-text-white" style="text-transform: initial">Valor: R$ {{ formatarValor(dadosMapaFinanceiro.total_contas_receber, 2) }}</strong>
          /
          <strong class="w3-text-white" style="text-transform: initial">Previsão: R$ {{ formatarValor(dadosMapaFinanceiro.total_previsoes_venda, 2) }}</strong>
          /
          <strong class="w3-text-white" style="text-transform: initial">Total: R$ {{ formatarValor(dadosMapaFinanceiro.total_receber) }}</strong>
          /
          <strong class="w3-text-white" style="text-transform: initial">AV: 100,00</strong> 
        </div>
      </div><!-- container -->
    </div><!-- w3-card -->
  
    <!-- CONTAS A PAGAR -->
    <div class="w3-card w3-panel  w3-padding-small" >
      <div class="container">
        <div class="w3-row">
          <strong class="w3-text-theme" style="text-transform: uppercase">Contas a pagar</strong>
          <div class="w3-col s12 card-box">
            <table class="w3-table w3-striped w3-bordered w3-hide-small w3-hide-medium">
                <tr style="background: #f1f1f1">
                  <th><strong>Tipo</strong></th>
                  <th><strong>Valor</strong></th>
                  <th><strong>Previsão</strong></th>
                  <th><strong>Total</strong></th>
                  <th><strong>AV</strong></th>
                </tr>
                <tbody v-for="item in dados.contas_pagar">
                  <tr v-if="item.mostrar" @click="toogleCard(item, false)" class="tr-items-ativo tr-items">
                    <td v-if="item.plano_financeiro_pai" >
                      {{ item.plano_financeiro_pai_id }} - {{ item.plano_financeiro_pai }}
                    </td>
                    <td v-else >
                      SEM PLANO
                    </td>
                    <td>R$ {{ formatarValor(item.soma_valor_contas_pagar, 2) }}</td>
                    <td>R$ {{ formatarValor(item.soma_previsao_contas_pagar, 2) }}</td>
                    <td>R$ {{ formatarValor(item.soma_total_contas_pagar, 2) }}</td>
                    <td>{{ formatarValor(((item.soma_total_contas_pagar / (dadosMapaFinanceiro.total_contas_pagar + dadosMapaFinanceiro.total_previsoes_pagar)) * 100), 4) }}</td>
                  </tr>
                  <tr v-if="!item.mostrar" @click="toogleCard(item, true)" class="tr-items">
                    <td v-if="item.plano_financeiro_pai" >
                      {{ item.plano_financeiro_pai_id }} - {{ item.plano_financeiro_pai }}
                    </td>
                    <td v-else >
                      SEM PLANO
                    </td>
                    <td>R$ {{ formatarValor(item.soma_valor_contas_pagar, 2) }}</td>
                    <td>R$ {{ formatarValor(item.soma_previsao_contas_pagar, 2) }}</td>
                    <td>R$ {{ formatarValor(item.soma_total_contas_pagar, 2) }}</td>
                    <td>{{ formatarValor(((item.soma_total_contas_pagar / (dadosMapaFinanceiro.total_contas_pagar + dadosMapaFinanceiro.total_previsoes_pagar)) * 100), 4) }}</td>
                  </tr>
                  <transition name="fade" tag="tr" mode="out-in">
                    <tr colspan="5" v-if="item.mostrar" class="tr-interno-background">
                      <td class="mapa-financeiro-card" colspan="5">
                        <table class="w3-table w3-striped w3-bordered table-interior" >
                          <tr class="tr-titulo" style="background: #f1f1f1">
                            <th>Tipo</th>
                            <th>Valor</th>
                            <th>Previsão</th>
                            <th>Total</th>
                            <th>AV</th>
                          </tr>
                          <tbody class="">
                            <tr v-for="conta in item.contas_pagar" @click="toogleCard(dados, false)" class="tr-subitems">
                              <td class="">{{ conta.nome }}</td>
                              <td>R$ {{ conta.total }}</td>
                              <td>R$ {{ conta.total_previsao }}</td>
                              <td> R$ {{ formatarValor(valor(conta.total) + valor(conta.total_previsao), 2) }}</td>
                              <td>{{ formatarValor(((valor(conta.total) + valor(conta.total_previsao)) / valor(dadosMapaFinanceiro.total_receber)) * 100, 4) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </transition>
                </tbody>
            </table>
            <div class="w3-hide-large card-informacoes" :class="{'card-ativo': item.mostrar}" v-for="(item, index) in dados.contas_pagar" :key="index" @click="toogleCard(item, !item.mostrar)">
              <div class="w3-col s12">
                <strong>Tipo</strong>
                <label v-if="item.plano_financeiro_pai" class="w3-right">{{ item.plano_financeiro_pai_id }} - {{ item.plano_financeiro_pai }}</label>
                <label v-else class="w3-right">SEM PLANO</label>
              </div>
              <div class="w3-col s12">
                <strong>Valor</strong>
                <label class="w3-right">R$ {{ formatarValor(item.soma_valor_contas_pagar, 2) }}</label>
              </div>
              <div class="w3-col s12">
                <strong>Previsão</strong>
                <label class="w3-right">R$ {{ formatarValor(item.soma_previsao_contas_pagar, 2) }}</label>
              </div>
              <div class="w3-col s12">
                <strong>Total</strong>
                <label class="w3-right">R$ {{ formatarValor(item.soma_total_contas_pagar, 2) }}</label>
              </div>
              <div class="w3-col s12">
                <strong>AV</strong>
                <label class="w3-right">{{ formatarValor(((item.soma_total_contas_pagar / (dadosMapaFinanceiro.total_contas_pagar + dadosMapaFinanceiro.total_previsoes_pagar)) * 100), 4) }}</label>
              </div>
              <transition-group name="fade" tag="div" mode="out-in">
                <div class="w3-hide-large card-informacoes card-interno" v-if="item.mostrar" v-for="conta in item.contas_pagar" @click="toogleCard(dados, false)">
                  <div class="w3-col s12">
                    <strong>Tipo</strong>
                    <label class="w3-right">{{ conta.nome }}</label>
                  </div>
                  <div class="w3-col s12">
                    <strong>Valor</strong>
                    <label class="w3-right">R$ {{ conta.total }}</label>
                  </div>
                  <div class="w3-col s12">
                    <strong>Previsão</strong>
                    <label class="w3-right">R$ {{ conta.total_previsao }}</label>
                  </div>
                  <div class="w3-col s12">
                    <strong>Total</strong>
                    <label class="w3-right">R$ {{ formatarValor(valor(conta.total) + valor(conta.total_previsao), 2) }}</label>
                  </div>
                  <div class="w3-col s12">
                    <strong>AV</strong>
                    <label class="w3-right">{{ formatarValor(((valor(conta.total) + valor(conta.total_previsao)) / valor(dadosMapaFinanceiro.total_receber)) * 100, 4) }}</label>
                  </div>
                </div>
              </transition-group>
            </div>
          </div><!-- card-box -->
        </div><!-- row -->
        <div class="w3-row w3-margin-top w3-vermelho" style="padding: 10px">
          <strong class="w3-text-white" style="text-transform: initial">Valor: R$ {{ formatarValor(dadosMapaFinanceiro.total_contas_pagar, 2) }}</strong>
          /
          <strong class="w3-text-white" style="text-transform: initial">Previsão: R$ {{ formatarValor(dadosMapaFinanceiro.total_previsoes_pagar, 2) }}</strong>
          /
          <strong class="w3-text-white" style="text-transform: initial">Total: R$ {{ formatarValor(dadosMapaFinanceiro.total_contas_pagar + dadosMapaFinanceiro.total_previsoes_pagar, 2) }}</strong>
          /
          <strong class="w3-text-white" style="text-transform: initial">AV: 100,00</strong> 
        </div>
      </div><!-- container -->
    </div><!-- w3-card -->
  </div><!-- analitico-modelo-dois -->
</template>

<script>
import Biblioteca from '@/components/Repositorio/Biblioteca';
import formatarValorMixin from '@/mixins/formatarValorMixin.js';

export default {
  name: 'MapaFinanceiroCardModeloDois',
  props: ['dados', 'dadosMapaFinanceiro'],
  mixins:[formatarValorMixin],

  data() {
    return {
      api: process.env.API,
      processando: false,
      expansor: 'closed'
    }
  },

  methods: {
    toogleCard(index, condicional) {
      this.$set(index, 'mostrar', condicional)
    },

    valor(numero){
      return Biblioteca.valor(numero);
    }
  },
}
</script>

<style scoped>
  .w3-card {
    padding: 20px
  }

  .chip-vencimento {
    border-radius: 25px;
    cursor: pointer;
    font-size: .9em;
    padding: 10px 15px;
    text-decoration: underline;
  }

  .card-box {
    border-left: 3px solid #9c1d1c;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #636363 ;
    padding: 5px 10px;
  }

  .card-box .w3-text-theme {
    text-transform: uppercase;
  }

  .contas-card {
    text-transform: capitalize
  }
  .card-box {
    overflow: auto;
  }
  th, td {
    white-space: nowrap;
  }
  .tr-items-ativo {
    background: #9c1d1c;
    color: white;
}

  .tr-items:hover {
    background: #9c1d1cb8;
    color:#fff;
    cursor: pointer;
  }
  .tr-subitems td:last-child{
  }
  .mapa-financeiro-card {
    padding-left: 8px !important;
    margin: 10px !important;
  }
  .tr-subitems {
    border: 1px solid #f1f1f1;
    
    background: white;

  }

  .w3-bordered {
    border: 2px solid #f1f1f1;
    border-top: 0px;
    
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  tr {
      transition: 0.3s;

  }
  .w3-vermelho {
    background: #9c1d1c;
  }
  .table-interior {
    border: 1px solid #b1b1b1 !important;

  }

  .tr-interno-background {
    background: #d4d4d4 !important
  }

  .tr-titulo {
    background: rgb(241, 241, 241);
  }
  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363 !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    width: 100%;
    border-bottom-color: #636363 !important;
  }
  .card-ativo {
    background: #d4d4d4;
    border-left-color: #9c1d1c !important;

  }
  .card-interno {
    background: white;
    /* box-shadow: 0 4px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12); */
  }
  .w3-card{
    padding: 0
  }
</style>


// WEBPACK FOOTER //
// src/components/MapaFinanceiroCardModeloDois.vue